<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Admin"
}
</script>

<style scoped>

</style>
